import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { TextField, Button, Typography, Box, Alert, Grid, Paper } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import eBrary_Logo from '../assets/Logoa.png';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    if (token && user) {
      navigate('/mycourse');
    }
  }, []);

  const handleLogin = async (event) => {
    event.preventDefault();
    setError(null);

    try {
      const response = await axios.post(`https://backend.scholarkart.in/api/login`, {
        username,
        password,
      });

      const { token } = response.data;
      localStorage.setItem('token', token);
      localStorage.setItem('loginTime', new Date().toISOString());

      // ✅ Fetch full user profile from backend
      const userRes = await axios.get('https://backend.scholarkart.in/api/user/me', {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const user = userRes.data;
      localStorage.setItem('user', JSON.stringify(user));

      // ✅ Save LoginLog after login
      if (user.collegeId) {
        await axios.post('https://backend.scholarkart.in/api/loginlog', {
          userId: user._id,
          collegeId: user.collegeId
        }, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      }

      navigate('/mycourse');

    } catch (error) {
      if (error.response && error.response.status === 422) {
        setError('Username and password are required.');
      } else if (error.response && error.response.data) {
        setError(error.response.data.msg || 'Login failed. Please try again.');
      } else {
        setError('Unexpected error occurred.');
      }
    }
  };

return (
  <Grid
    container
    sx={{
      height: '100vh',
      width: '100vw',
    }}
  >
    {/* Left Panel */}
    <Grid 
      item 
      sx={{
        width: {
          xs: '100%',  // 100% on mobile (xs = 0px and up)
          md: '50%',   // 50% on desktop (md = 900px and up)
        }
      }} 
      component={Paper} 
      elevation={6} 
      square
    >
      <Box
        sx={{
          mx: 8,
          my: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Link to="/">
          <img src={eBrary_Logo} alt="Sva Learn Logo" style={{ height: 70 }} />
        </Link>
        <Typography
          component="h1"
          variant="h5"
          sx={{
            fontWeight: 'bold',
            textAlign: 'center',
            textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
          }}
        >
          Transformation of eLearning Experience.
        </Typography>
        <Typography sx={{ mt: 1, mb: 2 }}>
          Unleash your potential - engage, explore, and excel with Sva Learn.
        </Typography>

        {error && <Alert severity="error" sx={{ width: '100%' }}>{error}</Alert>}

        <Box component="form" noValidate onSubmit={handleLogin} sx={{ mt: 1, width: '100%' }}>
          <TextField fullWidth margin="normal" label="Username" value={username} onChange={(e) => { setUsername(e.target.value); setError(null); }} />
          <TextField fullWidth margin="normal" label="Password" type="password" value={password} onChange={(e) => { setPassword(e.target.value); setError(null); }} />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              mt: 3,
              background: 'linear-gradient(to right,rgb(7, 67, 197),rgb(11, 2, 114))',
              color: 'white',
            }}
          >
            LOG IN
          </Button>
            <Typography variant="body2" align="center" sx={{ mt: 2 }}>
              <Link to="/ForgotPasswordPage" style={{ textDecoration: 'none', color: '#1976d2' }}>
                Forgot password?
              </Link>
            </Typography>
          <Box textAlign="center" mt={2}>
            <Typography variant="body2">
              Don&apos;t have an account?
              <Button
                variant="outlined"
                size="small"
                onClick={() => navigate('/SignupPage')}
                sx={{
                  ml: 1,
                  borderColor: 'rgb(11, 2, 114)',
                  color: 'rgb(11, 2, 114)',
                  fontWeight: 'bold'
                }}
              >
                CREATE NEW
              </Button>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Grid>

    {/* Right Panel */}
    <Grid
      item
      sx={{
        width: '50%',
        background: 'linear-gradient(to right,rgb(11, 2, 114),rgb(7, 67, 197))',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        px: 6,
        display: { xs: 'none', md: 'flex' }
      }}
    >
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Your education, your way. Access courses, anytime, anywhere.
      </Typography>
      <Typography variant="body1">
        Welcome to Sva Learn - the ultimate destination for seamless learning and exploration! Access Lesson Notes, Takeaways, Flash Cards, Mind Maps, Quizzes and AI Chatbot.
      </Typography>
    </Grid>
  </Grid>
);

};

export default LoginPage;
